<div class="cabboton container p-3 my-3 bg-cabimp text-white">
    <button  class="btn btn-cave" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon>  Volver
    </button>
     <button style="margin-left:5px;" class="btn btn-success"   onClick="window.print()" >
      <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
    </button>
</div>
<div style="text-align: center;">
  <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
</div>

<div class="cuerpo">
   <h2 class="heading" style="text-align: center;">ANTICIPOS </h2>
   <h3 class="heading" style="text-align: center;">{{nomusu}} </h3>

   <table id="tabla" class="table table-bordered row-border hover">
           <thead>
             <tr>
               <th >Fecha</th>
               <th >Anticipo</th>
               <th >Importes uva</th>
               <th >IVA</th>
               <th >Capital</th>
               <th >Compras</th>
               <th >Retenciones</th>
               <th >Total Neto</th>
             </tr>
           </thead> 
           <tbody>
             <tr *ngFor="let dato of datosTabla"> 
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}">{{ dato.tbFec }}</td>
               <td *ngIf="dato.tbAnt > 0" [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbAnt }}</td> 
               <td *ngIf="dato.tbAnt === 0" >  </td> 
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbImp | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbIva | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbAnu | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbVta | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbRet | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.tbFec === 'TOTALES'}" class="numero">{{ dato.tbNeto | number: '.2'}}</td> 
             </tr> 
           </tbody> 
   </table>
 
</div>

